<template>
  <el-dialog :title="!dataForm.id ? '新增' : '修改'" :modal-append-to-body="false" :show-close="false"
    :close-on-click-modal="false" :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
      label-width="80px">
      <el-form-item label="名称" prop="name">
        <el-input v-model="dataForm.name" placeholder="点位名称"></el-input>
      </el-form-item>
      <el-form-item label="企业">
        <el-select v-model="dataForm.companyId" placeholder="请选择企业" style="width: 100%">
          <el-option v-for="item in companyOption" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="国家" prop="countryId">
        <el-select v-model="dataForm.countryId" @change="getProvinceOption" placeholder="请选择国家" style="width: 100%">
          <el-option v-for="item in countryOption" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="省份">
        <el-select v-model="dataForm.provinceId" @change="getCityOption" placeholder="请选择省份" style="width: 100%">
          <el-option v-for="item in provinceOption" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="城市">
        <el-select v-model="dataForm.cityId" @change="getDistrictOption" placeholder="请选择城市" style="width: 100%">
          <el-option v-for="item in cityOption" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="区域">
        <el-select v-model="dataForm.districtId" @change="getStreetOption" placeholder="请选择区域" style="width: 100%">
          <el-option v-for="item in districtOption" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="街道">
        <el-select v-model="dataForm.streetId" placeholder="请选择街道" style="width: 100%">
          <el-option v-for="item in streetOption" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="地址" prop="address">
        <el-input v-model="dataForm.address" placeholder="地址" id="searchPoint"></el-input>
        <input type="button" value="搜索" @click="search()" class="list-ss" />
      </el-form-item>
      <el-form-item label="经度" prop="longitude">
        <el-input v-model="dataForm.longitude" placeholder="经度"></el-input>
      </el-form-item>
      <el-form-item label="纬度" prop="latitude">
        <el-input v-model="dataForm.latitude" placeholder="纬度"></el-input>
      </el-form-item>
    </el-form>
    <p style="display: none;">{{ dizhi }}</p>
    <div id="mapTD"></div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>
<style scoped>
.list-ss {
  position: absolute;
  right: 0;
  height: 40px;
  width: 50px;
  cursor: pointer;
}

#mapTD {
  height: 250px;
  width: 100%;
}
</style>
<script>
import $ from 'jquery'
var map, marker;
var geocoder;
export default {
  data() {
    return {
      visible: false,
      companyOption: [],
      countryOption: [],
      provinceOption: [],
      cityOption: [],
      districtOption: [],
      streetOption: [],
      enumOption: [],
      dataForm: {
        id: 0,
        companyId: '',
        countryId: '',
        provinceId: '',
        cityId: '',
        districtId: '',
        streetId: '',
        address: '',
        status: '',
        longitude: '',
        latitude: '',
        createTime: '',
        updateTime: ''
      },
      dataRule: {
        name: [
          { required: true, message: '点位名称不能为空', trigger: 'blur' }
        ],
        companyId: [
          { required: true, message: '企业ID不能为空', trigger: 'blur' }
        ],
        countryId: [
          { required: true, message: '国家不能为空', trigger: 'blur' }
        ],
        provinceId: [
          { required: true, message: '省份ID不能为空', trigger: 'blur' }
        ],
        cityId: [
          { required: true, message: '城市ID不能为空', trigger: 'blur' }
        ],
        districtId: [
          { required: true, message: '区域ID不能为空', trigger: 'blur' }
        ],
        streetId: [
          { required: true, message: '街道ID不能为空', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '地址不能为空', trigger: 'blur' }
        ],
        longitude: [
          { required: true, message: '经度不能为空', trigger: 'blur' }
        ],
        latitude: [
          { required: true, message: '纬度不能为空', trigger: 'blur' }
        ],
      },
      dizhi: ""
    }
  },
  created() {
    this.getMapp();
  },
  methods: {
    searchResult(result) {
      this.dizhi = result.location.lon;
      if (result.getStatus() == 0) {
        console.log(result);
        this.dataForm.address = result.formatted_address;
        this.dataForm.longitude = result.location.lon;
        this.dataForm.latitude = result.location.lat;
        map.panTo(result.getLocationPoint(), 16);
        //创建标注对象
        marker = new T.Marker(result.getLocationPoint());
        //向地图上添加标注
        map.addOverLay(marker);
      } else {
        alert(result.getMsg());
      }
    },
    searchResulted(result) {
      this.dizhi = result.location.lon;
      if (result.getStatus() == 0) {
        console.log(result);
        this.dataForm.longitude = result.location.lon;
        this.dataForm.latitude = result.location.lat;
        map.panTo(result.getLocationPoint(), 16);
        //创建标注对象
        marker = new T.Marker(result.getLocationPoint());
        //向地图上添加标注
        map.addOverLay(marker);
      } else {
        alert(result.getMsg());
      }
    },
    getMapp() {
      this.$http({
        url: this.$http.adornUrl("poi/list"),
        method: "get",
      }).then(({ data }) => {
        let _this = this;
        map = new T.Map("mapTD")
        //设置显示地图的中心点和级别
        map.centerAndZoom(new T.LngLat(105.953743, 28.50441), 12)
        //允许鼠标双击放大地图
        map.enableScrollWheelZoom();
        //创建对象
        geocoder = new T.Geocoder();
        map.addEventListener("click", function (e) {
          map.clearOverLays();
          geocoder.getLocation(e.lnglat, _this.searchResult);
          marker = new T.Marker(new T.LngLat(e.lnglat.lng, e.lnglat.lat));
          //创建标注对象
          map.addOverLay(marker);
        });
      });
    },
    search() {
      map.clearOverLays();
      geocoder.getPoint(this.dataForm.address, this.searchResulted);
    },
    // handleClone(obj){
    //   const  newObj = object.assign(_.cloneDeep(obj),{
    //     fieldId:`${obj.name}_${new Date().getTime()}`,
    //   })
    //   return newObj
    // },
    init(id) {
      this.getCompanyOption()
      this.getCountryOption()
      this.getStatusOption()
      this.dataForm = {}
      this.companyOption = []
      this.countryOption = []
      this.provinceOption == []
      this.cityOption = []
      this.districtOption = []
      this.streetOption = []
      this.enumOption = []
      if (id) {//修改
        this.dataForm.id = id
        this.$nextTick(() => {
          if (this.dataForm.id) {
            this.$http({
              url: this.$http.adornUrl("poi/list"),
              method: 'get',
              params: this.$http.adornParams(
                {
                  'pageNum': 1,
                  'pageSize': 1,
                  id: id
                }
              )
            }).then(({ data }) => {
              if (data && data.code === 200) {
                let data_ = data.data.rows[0]
                if (data_) {
                  if (data_.countryId) this.getProvinceOption(data_.countryId)
                  if (data_.provinceId) this.getCityOption(data_.provinceId)
                  if (data_.cityId) this.getDistrictOption(data_.cityId)
                  if (data_.districtId) this.getStreetOption(data_.districtId)
                  this.dataForm = data_
                }
              }
            })
          }
        })
      } else {
        this.dataForm.id = null
      }
      this.visible = true
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl(`/poi/${!this.dataForm.id ? 'save' : 'update'}`),
            method: 'post',
            data: this.$http.adornData({
              'id': this.dataForm.id || null,
              'companyId': this.dataForm.companyId,
              'countryId': this.dataForm.countryId,
              'provinceId': this.dataForm.provinceId,
              'cityId': this.dataForm.cityId,
              'districtId': this.dataForm.districtId,
              'streetId': this.dataForm.streetId,
              'address': this.dataForm.address,
              // 'status': this.dataForm.status,
              'longitude': this.dataForm.longitude,
              'latitude': this.dataForm.latitude,
              'name': this.dataForm.name,
            })
          }).then(({ data }) => {
            if (data && data.code === 200) {
              this.visible = false
              this.$emit('refreshDataList')
              this.$message({
                message: data.msg,
                type: 'success',
                duration: 1000,
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    },
    //获取企业option
    getCompanyOption() {
      this.$http({
        url: this.$http.adornUrl("/company/option"),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.companyOption = data.data.companyOption
        }
      })
    },
    //获取国家option
    getCountryOption() {
      this.$http({
        url: this.$http.adornUrl("/area/option/0"),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.countryOption = data.data.areaOption
        }
      })
    },
    //获取省份
    getProvinceOption(selectValue) {
      this.$http({
        url: this.$http.adornUrl("/area/option/" + selectValue),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.provinceOption = data.data.areaOption
        }
      })
    },
    //获取城市
    getCityOption(selectValue) {
      this.$http({
        url: this.$http.adornUrl("/area/option/" + selectValue),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.cityOption = data.data.areaOption
        }
      })
    },
    //获取区域
    getDistrictOption(selectValue) {
      this.$http({
        url: this.$http.adornUrl("/area/option/" + selectValue),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.districtOption = data.data.areaOption
        }
      })
    },
    //获取街道
    getStreetOption(selectValue) {
      this.$http({
        url: this.$http.adornUrl("/area/option/" + selectValue),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.streetOption = data.data.areaOption
        }
      })
    },
    //获取设备状态
    getStatusOption() {
      this.$http({
        url: this.$http.adornUrl("/configOption/option/0"),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.enumOption = data.data.enumOption
        }
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/admincenter/poi-add-or-update.vue